<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" color="#007BFF" :is-full-page="true"></loading>
    <base-header class="pb-6"></base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-body">
          <div v-if="loadFailed" class="store store--failed">
            {{ LOAD_ERROR }}
          </div>
          <div v-else-if="kitchen !== null" class="store">
            <div class="store__name">{{ kitchenName }}</div>
            <base-switch
              v-model="isOpen"
              type="primary"
              on-text="Abierta"
              off-text="Cerrada"
              @change="changeStatus"
            ></base-switch>
          </div>

          <ScheduleTable v-if="!loadFailed" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackofficeApi from '../../gateways/backoffice-api';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapActions } from 'vuex';
import ScheduleTable from './components/ScheduleTable';

const KITCHEN_PATH = '/api/v3/darkKitchens/';
const STATUS_PATH = '/api/v3/darkKitchens/status/';
const OPEN = 1;
const LOAD_ERROR =
  'No se pudo cargar el estado de tu tienda. Recargá la página para volver a intentarlo.';
const STATUS_ERROR =
  'No se pudo cambiar el estado de tu tienda. Volvé a intentarlo en unos segundos.';

export default {
  name: 'FoodcourtSchedule',
  components: { Loading, ScheduleTable },
  data() {
    return {
      LOAD_ERROR,
      isLoading: false,
      loadFailed: false,
      kitchen: null,
      isOpen: false
    };
  },
  async mounted() {
    if (this.kitchenId) {
      await this.load();
    }
  },
  computed: {
    kitchenId() {
      return this.$store.getters.getKitchenId;
    },
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace('/api/v1/', '');
    },
    kitchenName() {
      return this.kitchen === null ? '' : this.kitchen.name;
    }
  },
  methods: {
    ...mapActions('foodcourtSchedule', ['GET_SCHEDULE']),
    async load() {
      try {
        this.isLoading = true;
        this.loadFailed = false;
        const { data } = await BackofficeApi.get(
          `${this.host}${KITCHEN_PATH}${this.kitchenId}`
        );
        this.kitchen = data.detail.restaurant.dark_kitchen;
        this.isOpen = Number(this.kitchen.status) === OPEN;
        await this.GET_SCHEDULE();
      } catch (error) {
        this.loadFailed = true;
        this.kitchen = null;
        this.$notify({ type: 'danger', message: LOAD_ERROR });
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus() {
      const intended = this.isOpen;

      try {
        await BackofficeApi.put(
          `${this.host}${STATUS_PATH}${this.kitchen.id}`,
          { status: intended }
        );
      } catch (error) {
        this.isOpen = !intended;
        this.$notify({ type: 'danger', message: STATUS_ERROR });
      }
    }
  },
  watch: {
    kitchenId(value) {
      if (value && this.kitchen === null && !this.isLoading) {
        this.load();
      }
    }
  }
};
</script>

<style scoped>
.store {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border: 1px solid #e8e8e8;
  border-radius: 14px;
  max-width: 420px;
}
.store__name {
  font-size: 1rem;
  font-weight: 700;
  color: #171717;
}
.store--failed {
  display: block;
  border-color: #f5c6cb;
  background: #fdf3f4;
  color: #a12622;
  font-size: 0.85rem;
}
</style>
